import UiAdapter from 'Engine/base/ui/uiAdapter/BaseUiAdapter';
import eStateTypes from '../enums/eStateTypes';
import EntryPoint from 'Engine/EntryPoint';

export default class UiAdapterExtended extends UiAdapter {
  constructor(...props) {
    super(...props);
    this._bonusSpinsCountUpdateTimout = null;
  }

  disableButtons() {
    this.ControllerUi.toggleStopButton(false);
    this.ControllerUi.toggleSpinButton(false);

    this.ControllerUi.toggleAutoPlayButton(false);
    this.ControllerUi.toggleMenuButton(false);
    this.ControllerUi.toggleInfoButton(false);
    this.ControllerUi.toggleMaxBetButton(false);
    this.ControllerUi.toggleBetSelectors(false);
  }

  extraStateHandlers = {
    [eStateTypes.EST_IDLE]: () => {
      if (this._bonusSpinsCountUpdateTimout) {
        clearTimeout(this._bonusSpinsCountUpdateTimout);
        this._bonusSpinsCountUpdateTimout = null;
      }
    },
    [eStateTypes.EST_REQUEST_ROLLING]: () => {
      if (EntryPoint.GameModel.freespinsEnabled) {
        const lastBonusSpinsCount = EntryPoint.GameModel.freespins;
        this.ControllerUi.setFreeSpinsCount(EntryPoint.GameModel.freespins);
        this._bonusSpinsCountUpdateTimout = setTimeout(() => this.ControllerUi.setFreeSpinsCount(lastBonusSpinsCount - 1), 150);
      }
    },
    [eStateTypes.EST_REQUEST_ROLLING]: () => {
      if (EntryPoint.GameModel.freespinsEnabled) {
        const lastBonusSpinsCount = EntryPoint.GameModel.freespins;
        this.ControllerUi.setFreeSpinsCount(EntryPoint.GameModel.freespins);
        this._bonusSpinsCountUpdateTimout = setTimeout(() => this.ControllerUi.setFreeSpinsCount(lastBonusSpinsCount - 1), 150);
      }
    },
    [eStateTypes.EST_WIN_COLLECT]: () => {
      this.ControllerUi.showSpinButton();
      this.disableButtons();

      if (this._bonusSpinsCountUpdateTimout) {
        clearTimeout(this._bonusSpinsCountUpdateTimout);
        this._bonusSpinsCountUpdateTimout = null;
      }
      this.ControllerUi.setFreeSpinsCount(EntryPoint.GameModel.freespins);
    },
    [eStateTypes.EST_RESET_BONUS_FIELD]: () => {
      this.ControllerUi.showSpinButton();
      this.disableButtons();
    },
    [eStateTypes.EST_OPEN_JACKPOT_BOXES]: () => {
      this.ControllerUi.showSpinButton();
      this.disableButtons();
    },
    [eStateTypes.EST_WIN_MULTIPLY]: () => {
      this.ControllerUi.showSpinButton();
      this.disableButtons();

      this.ControllerUi.setWin(EntryPoint.GameModel.bonusField.total_win_multiplied);
      this.ControllerUi.setTotalWin(EntryPoint.GameModel.freespinsTotalWin);
    },
    default: () => {
    },
  };

  handleExtras() {
    super.handleExtras();

    if (EntryPoint.GameModel.freespinsEnabled) {
      this.ControllerUi.showSpinButton();
    }
  }
}
